import OrderableTypes from "./OrderableTypes";

const DeliveryMethods = {
	ETicket: 1,
	Collection: 2,
	Post: 3,
	PostGiftPack: 4
};

const OrderableTypesRequiringDelivery =
[
	OrderableTypes.TicketTravel,
	OrderableTypes.TicketSession,
	OrderableTypes.VoucherSale
];

const getLabel = value => {
	switch (value) {
		case DeliveryMethods.ETicket:
			return "E-Ticket";
		case DeliveryMethods.Collection:
			return "Collect on arrival";
		case DeliveryMethods.Post:
			return "Post";
		case DeliveryMethods.PostGiftPack:
			return "Post — Gift Pack";
		default:
			return "Unknown";
	}
};

const getOrderableName = value => {
	switch (value) {
		case DeliveryMethods.ETicket:
			return "E-Ticket Delivery";
		case DeliveryMethods.Collection:
			return "Collection at the ticket office";
		case DeliveryMethods.Post:
			return "Postal Delivery";
		case DeliveryMethods.PostGiftPack:
			return "Postal Delivery — Gift Pack";
		default:
			return "Unknown";
	}
};

export default DeliveryMethods;
export {DeliveryMethods as values, OrderableTypesRequiringDelivery, getLabel, getOrderableName};
